import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";

import PageChange from "../../../component/pageChange"
import Layout from "../../../component/Layout/Layout";
import Card from "../../../component/Layout/theme/card";
import LogOut from "../../../component/dashboard/user/logout/logout";
import toast from "react-hot-toast";




function IndexPage() {
    var { t } = useTranslation()
    const { login, token, user } = useSelector((item) => item.user)
    const [isDataLoad, setIsDataLoad] = useState(false);
    const [currentPlanData, setCurrentPlanData] = useState({})
    const [chosenPlanData, setChosenPlanData] = useState({})
    const [discountCodeData, setDiscountCodeData] = useState(null)
    const [plansData, setPlansData] = useState([])
    let params = useParams();


    useEffect(() => {
        document.title = "پلن های مالی"
        if (!login) {
            window.location.href = '/auth'
        } else {
            getPlansData()
        }
    }, [])

    async function getPlansData() {
        // توکن ب سرور داده شده و اطلاعات کاربر دریافت
        await fetch(`${process.env.REACT_APP_SERVER}/api/billing/plans`, {
            method: "GET",
            headers: {
                Authorization: "ArNew " + token,
            },
        }).then((res) => {
            res
                .json()
                .then((result) => {
                    if (!result.data) {
                        LogOut();
                        toast.error("شما دسترسی ندارید");
                        window.location.href = '/login';
                    }
                    if (result.status === "success") {
                        setIsDataLoad(true)
                        setChosenPlanData(result.data.plans.filter((elem) => elem._id == params.id)[0])
                        setPlansData(result.data.plans)
                        setCurrentPlanData(result.data.current)
                    } else {
                        toast.error(result.msg);
                        LogOut();
                        window.location.href = '/login';
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        });
    }


    const getPeriodPay = (period) => {
        switch (period) {
            case "UNLIMITED":
                return "نامحدود"
            case "MONTHLY":
                return "ماهانه"
            case "YEARLY":
                return "ماهانه"
            default:
                return "نامشخص"
        }
    }

    const getPricePay = (data) => {
        if (data.plan.currency === "FREE") {
            return "رایگان"
        } else {
            return "تست"
        }
    }

    const calPeriodPrice = (period, price) => {
        switch (period) {
            case "UNLIMITED":
                return price * 1
            case "MONTHLY":
                return price * 1
            case "YEARLY":
                return price * 12
            default:
                return "نامشخص"
        }
    }

    return (
        <>
            <Layout />
            <Card>
                {isDataLoad ? (
                    <div className="p-5 mb-24 bg-white rounded-lg shadow-md">
                        <h1 className="font-extrabold text-2xl text-start text-black mt-5">خرید اشتراک</h1>
                        <h4 className="font-normal text-lg text-start text-gray-500 mt-2">طرح انتخابی شما به شرح زیر می باشد، پس تایید شما به درگاه پرداخت متصل خواهید شد.</h4>

                        {currentPlanData ?
                            (
                                <>
                                    <h1 className="font-extrabold text-xl text-start text-black mt-8 mx-5">طرح فعال فعلی</h1>
                                    <div className="p-8 mt-3 bg-[#f2f4f6] rounded-lg border border-[#e6e8ea]">
                                        <div className="grid grid-cols-2 xl:grid-cols-5 lg:grid-cols-3 gap-3">
                                            <div className="">
                                                <span className="font-bold text-start text-gray-400">اکانت فعلی</span>
                                                <h3 className="font-extrabold text-xl text-start text-black py-5">{currentPlanData.name}</h3>
                                            </div>
                                            <div className="">
                                                <span className="font-bold text-start text-gray-400">تعداد واقعیت افزوده</span>
                                                <h3 className="font-extrabold text-xl text-start text-black py-5">{currentPlanData.count == 0 ? "نامحدود" : currentPlanData.count}</h3>
                                            </div>
                                            <div className="">
                                                <span className="font-bold text-start text-gray-400">محدودیت بازدید</span>
                                                <h3 className="font-extrabold text-xl text-start text-black py-5">{currentPlanData.view_limited == 0 ? "نامحدود" : currentPlanData.view_limited}</h3>
                                            </div>
                                            <div className="">
                                                <span className="font-bold text-start text-gray-400">قیمت (تومان)</span>
                                                <h3 className="font-extrabold text-xl text-start text-black py-5">{currentPlanData.price}</h3>
                                            </div>
                                            <div className="">
                                                <span className="font-bold text-start text-gray-400">دوره</span>
                                                <h3 className="font-extrabold text-xl text-start text-black py-5">{getPeriodPay(currentPlanData.period)}</h3>
                                            </div>
                                        </div>
                                    </div>

                                </>
                            ) : null
                        }

                        <h1 className="font-extrabold text-xl text-start text-black mt-8 mx-5">طرح انتخابی شما</h1>
                        <div className="p-8 mt-3 bg-[#f2f4f6] rounded-lg border border-[#e6e8ea]">
                            <div className="grid grid-cols-2 xl:grid-cols-5 lg:grid-cols-3 gap-3">
                                <div className="">
                                    <span className="font-bold text-start text-gray-400">اکانت جدید</span>
                                    <h3 className="font-extrabold text-xl text-start text-black py-5">{chosenPlanData.name}</h3>
                                </div>
                                <div className="">
                                    <span className="font-bold text-start text-gray-400">تعداد واقعیت افزوده</span>
                                    <h3 className="font-extrabold text-xl text-start text-black py-5">{chosenPlanData.count == 0 ? "نامحدود" : chosenPlanData.count}</h3>
                                </div>
                                <div className="">
                                    <span className="font-bold text-start text-gray-400">محدودیت بازدید</span>
                                    <h3 className="font-extrabold text-xl text-start text-black py-5">{chosenPlanData.view_limited == 0 ? "نامحدود" : chosenPlanData.view_limited}</h3>
                                </div>
                                <div className="">
                                    <span className="font-bold text-start text-gray-400">قیمت (تومان)</span>
                                    <h3 className="font-extrabold text-xl text-start text-black py-5">{chosenPlanData.price.toLocaleString('en-US')}</h3>
                                </div>
                                <div className="">
                                    <span className="font-bold text-start text-gray-400">دوره</span>
                                    <h3 className="font-extrabold text-xl text-start text-black py-5">{getPeriodPay(chosenPlanData.period)}</h3>
                                </div>
                            </div>
                        </div>

                        <h1 className="font-extrabold text-xl text-start text-black mt-8 mx-5">پرداخت</h1>
                        <div className="p-8 mt-3 bg-[#f2f4f6] rounded-lg border border-[#e6e8ea]">
                            <div className="grid grid-cols-2 xl:grid-cols-4 lg:grid-cols-2 gap-3">
                                <div className="">
                                    <span className="font-bold text-start text-gray-400">دوره پرداخت</span>
                                    <h3 className="font-extrabold text-xl text-start text-black py-5">{chosenPlanData.period == "YEARLY" ? 12 : 1} ماه</h3>
                                </div>
                                <div className="">
                                    <span className="font-bold text-start text-gray-400">قیمت هرماه (تومان)</span>
                                    <h3 className="font-extrabold text-xl text-start text-black py-5">{chosenPlanData.price.toLocaleString('en-US')}</h3>
                                </div>
                                <div className="">
                                    <span className="font-bold text-start text-gray-400">کد تخفیف</span>
                                    <h3 className="font-extrabold text-xl text-start text-black py-5">-</h3>
                                </div>
                                <div className="">
                                    <span className="font-bold text-start text-gray-400">مبلغ کل (تومان)</span>
                                    <h3 className="font-extrabold text-xl text-start text-black py-5">{calPeriodPrice(chosenPlanData.period, chosenPlanData.price).toLocaleString('en-US')}</h3>
                                </div>
                            </div>
                        </div>
                        <div className="flex justify-end gap-2 pt-5">
                            <Link to={"/billing/plan"}>
                                <button className="font-medium text-sm text-white  bg-red-600 hover:bg-red-700 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg px-5 py-2.5 text-center">انصراف</button>
                            </Link>
                            <Link to={`${process.env.REACT_APP_SERVER}/api/billing/pay/${user._id}/${calPeriodPrice(chosenPlanData.period, chosenPlanData.price)}/${discountCodeData}`}>
                                <button className="font-medium text-sm text-white  bg-green-600 hover:bg-green-700 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg px-5 py-2.5 text-center">خرید اشتراک</button>
                            </Link>
                        </div>
                    </div>
                ) : (
                    <PageChange />
                )}
            </Card>

        </>
    )
}

export default IndexPage
